export default __webpack_public_path__ + "static/media/bladeweave.aac89c04.png";